import { render, staticRenderFns } from "./BetslipButton.vue?vue&type=template&id=c0e6245c"
import script from "./BetslipButton.vue?vue&type=script&lang=js"
export * from "./BetslipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports